module.exports = __webpack_public_path__ + "img/Shopee.394391ec.png";